module.exports = __webpack_public_path__ + "img/food_category.3d7c0188.png";